import React, {useState,useEffect } from "react"
import {useStaticQuery, graphql} from 'gatsby'
import Footer from './footer'

const SlugWrapCommunityFooter = ({slug})=>{
    const data = useStaticQuery(graphql`
        query  ($slug: String){
          allContentfulCommunity(filter: {slug: {eq: $slug}}) {
            edges {
              node {
                id
                communityName
                slug
                address
                email
                phone
                area
                citySlug
                shortHours
              }
            }
          }
        }
        `
    )

    const [cdata, setCdata] = useState({});
    useEffect(()=>{
        data.allContentfulCommunity.edges.map((c)=>{
            if(c.node.slug == slug){
                setCdata({cname:c.node.communityName,cphone:c.node.phone,caddress:c.node.address,cemail:c.node.email});
            }
        });
    },[]);
    return(
        <Footer cname={cdata.cname} 
            phone={cdata.cphone} 
            address={cdata.caddress} 
            email={cdata.cemail} 
                hideFloatingContactButton={true}
            slug={slug}
            />
    )
}


export default SlugWrapCommunityFooter
